
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { State } from 'src/types';

// useFeatureFlag hook returns true or false if the Feature Flag is enabled
// run `enableFlag` from the browser console to enable the Feature Flag

export const useIsFeatureFlag = (): boolean => useSelector(({featureFlag}: State) => featureFlag.enabled);

export const useIsEnableFlagDev = (): boolean => {
  const isFeatureFlag = useSelector(({featureFlag}: State) => featureFlag.enabled);
  useEffect(() => {
    if (window.location.hostname === 'localhost') {
      window.enableFlag();
    }
  }, []);
  return isFeatureFlag;
};
